import React, {useEffect, useState, useRef} from 'react';
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import RedeemIcon from '@mui/icons-material/Redeem';
import { inject, observer } from "mobx-react";
import _useTranslate from '../hooks/_useTranslate';
import { MenuItem, TextField  } from '@mui/material';
import GreenSubmitButton from "../buttons/greenSubmitButton";
import Colors from '../assets/colors';

const TipModal = ({ 
  feathersStore,
  cashToPay,
  onButtonPress,
  onClosePress,
  visible = false
}) =>{ 

  const greenColored = {color: "hsl(151, 100%, 28%)", fontSize: 35, marginRight: 1}

  let common = _useTranslate(feathersStore.language, "common");  

  const [tip, setTip] = useState("0");
  const [tips, setTips] = useState([]);
  const [percentage, setPercentage] = useState(0);
  const tipRef = useRef(0); 

  useEffect(() => {
    if(feathersStore.settings?.tips){
      let tipsArray = feathersStore.settings?.tips?.map(t => t?.label) || [];
      if(!tipsArray.includes(0))tipsArray.push("0");
      setTips(tipsArray.sort((a, b) => a - b));
    }   
  },[feathersStore.settings?.tips])

  const onChangeTip = text => {     
    setTip(text);
    tipRef.current = text;
  }

  const _onButtonPress = () => {
    onButtonPress(parse_fix(tipRef.current)) 
    setTip("0");
    setPercentage(0);
    tipRef.current = 0;
    onClosePress();
  }

  const calcTipFromPercentage = (tipPercentage = 0) => {
    let disc = 0;
    if(tipPercentage > 0){  
      disc = cashToPay * tipPercentage / 100;
      setTip(parse_fix(disc));
    }else{
      setTip("0");
    }
    tipRef.current = disc;
  }

  const percentageChange = p => {    
    setPercentage(p);
    calcTipFromPercentage(+p)
  };

  const parse_fix = price => {
    return price ? parseFloat(price).toFixed(2) : 0;
  } 
    
  return(
    <>
    <div className="tip-alert-container">
      <CSSTransition
        in={visible}
        timeout={300}
        classNames="my-alert"
        unmountOnExit
      >
        <div className="tip-alert">
          <div className="copy-title-text">         
            <RedeemIcon sx={greenColored}/>          
            {common.enterTip} 
          </div> 
          <div className="alert-body-text">{`${common.textTotal}: ${feathersStore.formatMoney(cashToPay)}`}</div>
            <div className="tip-select-row">
              <TextField
                label={common.tip}
                variant="outlined" 
                type="number" 
                defaultValue={0}
                InputProps={{ inputProps: { min: "0", step: "0.10" } }}
                id="tip-input" 
                value={tip}
                onChange={(event) => onChangeTip(+event.target.value)}
              >               
              </TextField>        
              <div className="tip-second-input">             
                <TextField
                  select
                  label={'%'}
                  variant="outlined" 
                  type="number" 
                  defaultValue={0}
                  id="perc-input" 
                  value={+percentage}
                  onChange={(event) => percentageChange(+event.target.value)}                   
                  children={tips?.map((i) => (
                    <MenuItem key={i} value={i}>
                      {i}
                    </MenuItem>
                  ))}
                  >
                </TextField>                          
              </div>   
              <div>%</div>      
            </div>
            <div className="tip-button-container">        
              <GreenSubmitButton aria-labelledby='Set tip' 
                disabled={tip < 0}
                color={undefined}
                title={common.apply} 
                onClick={_onButtonPress} 
                width="100%"
              ></GreenSubmitButton>         
              <GreenSubmitButton aria-labelledby='Cancel' 
                color={undefined}
                title={common.exit} 
                onClick={onClosePress} 
                width="100%"
                variant="outlined"
              ></GreenSubmitButton>       
            </div> 
          <CloseIcon className="alert-close-icon"  onClick={onClosePress}/>
        </div>
      </CSSTransition>
    </div>
  </>
  )
}

export default inject('feathersStore')(observer(TipModal));